import { graphql } from '~/gql';

export const CreateRetainerRequestDocument = graphql(`
  mutation CreateRetainerRequest($input: CreateRetainerRequestInput!) {
    createRetainerRequest(input: $input) {
      ...RetainerFields
    }
  }
`);

export const StartRetainerFundingDocument = graphql(`
  mutation StartRetainerFunding($retainerId: BigInt!) {
    startRetainerFunding(retainerId: $retainerId)
  }
`);

export const DeclineRetainerDocument = graphql(`
  mutation DeclineRetainer($retainerId: BigInt!, $declinedMessage: String) {
    declineRetainer(
      retainerId: $retainerId
      declinedMessage: $declinedMessage
    ) {
      ...RetainerFields
    }
  }
`);

export const CloseRetainerDocument = graphql(`
  mutation CloseRetainer($retainerId: BigInt!, $closedMessage: String) {
    closeRetainer(retainerId: $retainerId, closedMessage: $closedMessage) {
      ...RetainerFields
    }
  }
`);

export const MarkRetainerWorkCompleteDocument = graphql(`
  mutation MarkRetainerWorkComplete($retainerId: BigInt!) {
    markRetainerWorkComplete(retainerId: $retainerId) {
      ...RetainerFields
    }
  }
`);

export const MarkRetainerWorkActiveDocument = graphql(`
  mutation MarkRetainerWorkActive($retainerId: BigInt!) {
    markRetainerWorkActive(retainerId: $retainerId) {
      ...RetainerFields
    }
  }
`);
